import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {DocumentMetadataResponse} from "../../entity/resource/document-metadata-response";
import {DocumentMetadataRequestDto} from "../../entity/dto/document-metadata-request-dto";
import {FilterMetadataRequestDto} from "../../entity/dto/filter-metadata-request-dto";
import {FilterMetadataResponse} from "../../entity/resource/filter-metadata-response";
import {MarketplaceRecordRequestDto} from "../../entity/dto/marketplace-record-request-dto";
import {MarketplaceRecordResponse} from "../../entity/resource/marketplace-record-response";

export default class MarketplaceAgent{

    getDocumentMetadata = async (payload: DocumentMetadataRequestDto): Promise<DocumentMetadataResponse | string> => {
        return await API.post(awsApiName, `/marketplace-document-metadata/data`, {body: payload});
    }

    filterMetaData = async (payload: FilterMetadataRequestDto): Promise<FilterMetadataResponse[] | string> => {
        return await API.post(awsApiName, `/marketplace-document-metadata/filter`, {body: payload});
    }

    createMarketplaceRecord = async (organizationID: string, payload: MarketplaceRecordRequestDto): Promise<MarketplaceRecordResponse | string> => {
        return await API.post(awsApiName, `/organizations/${organizationID}/marketplace-purchase-record`, {body: payload});
    }

    downloadMarketplaceDocument = async (organizationId: string, batchID: string): Promise<{success: boolean, message: string, downloadUrl: string, fileName: string, expiresIn: string}> => {
        const response = await API.get(awsApiName, `/organizations/${organizationId}/marketplace-purchase-record/download?batchID=${batchID}`, {});
        return response;
    }
}
